module.exports = __webpack_public_path__ + "img/hz2.b3cc2665.png";